import type { BleTransport, ConnectionState, TransportEvents } from './types';

/**
 * The honest floor.
 *
 * Collects the commands that would have been sent so the user can copy them
 * into a BLE terminal app (nRF Connect, LightBlue, Bluefy's console). Always
 * available, on every platform, forever. If every other transport fails this
 * one still drives the device — slowly, but it works.
 */
export class ManualTransport implements BleTransport {
  readonly id = 'manual' as const;
  readonly label = 'Manual (copy & paste)';
  readonly available = true;

  state: ConnectionState = 'disconnected';

  /** Commands accumulated since the last clear. */
  buffer: string[] = [];

  constructor(private events: TransportEvents) {}

  async connect(): Promise<void> {
    this.buffer = [];
    this.state = 'connected';
    this.events.onState('connected');
    this.events.onLog({
      at: Date.now(),
      dir: 'info',
      text: 'Manual mode. Commands will be collected for copy & paste.',
    });
  }

  async disconnect(): Promise<void> {
    this.state = 'disconnected';
    this.events.onState('disconnected');
  }

  async send(command: string): Promise<void> {
    this.buffer.push(command);
    this.events.onLog({ at: Date.now(), dir: 'tx', text: command });
  }

  /** Feed a response back by hand, so the UI can still be driven. */
  receive(raw: string): void {
    this.events.onLog({ at: Date.now(), dir: 'rx', text: raw });
    this.events.onMessage(raw);
  }
}
